import { Injectable } from '@angular/core';
import { LogService } from '@innovation-os-ng/core/logger';
import {
  EntityConfigControl,
  EntityConfigControlChild,
  EntityConfigControlInput,
  EntityConfigFieldInput,
  EntityConfigType,
  EntityConfigTypeInput
} from '@innovation-os-ng/core/shared';
import { GraphQLError } from 'graphql';
import { Observable, Subject } from 'rxjs';
import { EntityConfigRelationType } from '../model/relationType';

export enum ErrorUIType {
  VIOLATION = 'violation',
  NETWORK = 'network',
  INCOMPLETE = 'incomplete',
  REQUEST = 'request'
}

type ErrorElement =
  | EntityConfigType
  | EntityConfigTypeInput
  | EntityConfigControl
  | EntityConfigControlInput
  | EntityConfigControlChild
  | EntityConfigRelationType
  | EntityConfigFieldInput;

type ErrorValue =
  | string
  | Array<{
      description?: string;
      providedValue?: string;
      source?: string;
      localisationResourceId?: string;
    }>
  | ReadonlyArray<GraphQLError>;

export interface ErrorUI {
  type: ErrorUIType;
  value?: ErrorValue;
  element?: ErrorElement;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorUiService {
  private readonly error: Subject<ErrorUI> = new Subject();

  constructor(private readonly logger: LogService) {}

  public notifyError(error: ErrorUI) {
    // Some errors here are just informational we should not give them high priority
    this.logger.warn('There was an error', { error });

    // We notify to main component the error captured
    // this will output the error to the app host
    // Please do not remove the parameter error!
    this.error.next(error);
  }

  public onError(): Observable<ErrorUI> {
    return this.error.asObservable();
  }
}
